module.exports = __webpack_public_path__ + "3f7633582da4bf7b3d66686ce6f4ef01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room8/audio5/apartment.jpg
// module id = 231
// module chunks = 0